import {
  SeatColorsTypeEnum,
  SeatStatusOptionFilter,
  SelectionType,
  MultiQuickFilterSelection,
  BulkSelectionScope,
} from '@app/catalog-plan/models/catalog-plan.model';
import { BlockViewData } from '@core/models/catalog-plan.model';
import {
  EventSessionPlanHeaderResponseDto,
  EventSessionPlanBlockResponseDto,
  EventSessionVenueInformationLegendResponseDto,
  EventSessionPlanContingentResponseDto,
  EventSessionPlanCategoryResponseDto,
  EventSessionPlanUnavailableSeatTypesResponseDto,
  CatalogPlanEventTypeEnumResponseDto,
  FileResponse,
  CatalogPlanSeatResponseDto,
  EventSessionPlanContingentImageResponseDto,
  EventSessionStatsResponseDto,
  EventSessionMultiSelectionStatsResponseDto,
} from '@core/services/apiclient';
import { createAction, props } from '@ngrx/store';
export const initPlanView = createAction(
  '[CatalogPlan] Init Plan View',
  props<{
    eventSessionId: number;
    planType: CatalogPlanEventTypeEnumResponseDto;
    sourcePage: 'dashboard' | 'catalog';
  }>(),
);
export const reloadPlanView = createAction('[CatalogPlan] Reload Plan View');
export const loadPlanData = createAction('[CatalogPlan] Load Plan Data', props<{ blockId?: number }>());
export const refreshCatalogBlockViewSeatsData = createAction(
  '[CatalogPlan] Refresh BlockView Seats Data',
  props<{ blockId: number }>(),
);
export const refreshCatalogBlockViewSeatsDataSuccess = createAction(
  '[CatalogPlan] Refresh BlockView Seats Success',
  props<{
    seatsStampVersion: string;
  }>(),
);
export const refreshCatalogExcludingMultiBlocksViewSeatsData = createAction(
  '[CatalogPlan] Refresh Excluding Multi Blocks Seats Data',
);
export const refreshCatalogExcludingMultiBlocksSeatsSuccess = createAction(
  '[CatalogPlan] Refresh Excluding Multi Blocks Seats Success',
  props<{
    seatsStampVersion: string;
  }>(),
);
export const resetPlan = createAction('[CatalogPlan] Reset Plan');
export const setEventSessionId = createAction(
  '[CatalogPlan] Set Event SessionId',
  props<{
    eventSessionId: number;
  }>(),
);
export const setPlanType = createAction(
  '[CatalogPlan] Set Plan Type',
  props<{
    planType: CatalogPlanEventTypeEnumResponseDto;
  }>(),
);
export const setBlockViewData = createAction(
  '[CatalogPlan] Set Bloc View Data',
  props<{ blockViewData: BlockViewData }>(),
);

export const loadTopViewPlanDataSuccess = createAction(
  '[CatalogPlan] Load TopView Plan Data Success',
  props<{
    eventDetails: EventSessionPlanHeaderResponseDto;
    planBackground: FileResponse;
    planData: EventSessionPlanBlockResponseDto[];
    allContingentImages: EventSessionPlanContingentImageResponseDto[];
  }>(),
);
export const loadTopViewPlanDataFailure = createAction('[CatalogPlan] Load TopView Plan Data Failure');
export const loadBlockViewData = createAction(
  '[CatalogPlan] Load Bloc View Data',
  props<{ blockId: number; eventSessionId: number }>(),
);
export const loadBlockViewDataSuccess = createAction(
  '[CatalogPlan] Load Block View Data Success',
  props<{
    eventDetails: EventSessionPlanHeaderResponseDto;
    blockViewData: BlockViewData;
    seatsStampVersion: string;
  }>(),
);
export const loadBlockViewDataFailure = createAction('[CatalogPlan] Load Block View Data Failure');
export const loadExcludingMultiBlocksPlan = createAction(
  '[CatalogPlan] Load Excluding MultiBlocks Plan',
  props<{
    eventSessionId: number;
  }>(),
);
export const loadExcludingMultiBlocksPlanSuccess = createAction(
  '[CatalogPlan] Load Excluding MultiBlocks Plan Success',
  props<{
    eventDetails: EventSessionPlanHeaderResponseDto;
    blockViewData: BlockViewData;
    seatsStampVersion: string;
  }>(),
);
export const loadExcludingMultiBlocksPlanFailure = createAction(
  '[CatalogPlan] Load Excluding MultiBlocks Plan Failure',
);
export const loadLegendData = createAction('[CatalogPlan] Load Legend');
export const setLegend = createAction(
  '[CatalogPlan] Set Legend',
  props<{ legend: EventSessionVenueInformationLegendResponseDto }>(),
);
export const getSeatSearchResults = createAction(
  '[CatalogPlan] Get Seat Search Results',
  props<{ searchTerm: string }>(),
);
export const getSeatSearchResultsSuccess = createAction(
  '[CatalogPlan] Get Seat Search Results Success',
  props<{ results: any }>(),
);
export const setSelectionType = createAction(
  '[CatalogPlan] Set Selection Type',
  props<{ selectionType: SelectionType }>(),
);

export const loadContingentsFilterData = createAction('[CatalogPlan] Load Contingents Filter');
export const updateContingentsFilterList = createAction(
  '[CatalogPlan] Update Contingents Filter List',
  props<{ contingentsFilterList: EventSessionPlanContingentResponseDto[] }>(),
);
export const updateContingentIdsFilterSelected = createAction(
  '[CatalogPlan] Update ContingentIds Filter Selected',
  props<{ contingentIdsFilterSelected: number[] }>(),
);
export const loadCategoriesFilterData = createAction('[CatalogPlan] Load Categories Filter');
export const updateCategoriesFilterList = createAction(
  '[CatalogPlan] Update Categories Filter List',
  props<{ categoriesFilterList: EventSessionPlanCategoryResponseDto[] }>(),
);
export const updateCategoryIdsFilterSelected = createAction(
  '[CatalogPlan] Update CategoryIds Filter Selected',
  props<{ categoryIdsFilterSelected: number[] }>(),
);
export const loadUnavailableSeatTypesFilterData = createAction(
  '[CatalogPlan] Load UnavailableSeatTypes Filter',
);
export const updateUnavailableSeatTypesFilterList = createAction(
  '[CatalogPlan] Update UnavailableSeatTypeIds Filter List',
  props<{ unavailableSeatTypesFilterList: EventSessionPlanUnavailableSeatTypesResponseDto[] }>(),
);
export const updateUnavailableSeatTypeIdsFilterSelected = createAction(
  '[CatalogPlan] Update UnavailableSeatTypeIds Filter Selected',
  props<{ unavailableSeatTypeIdsSelected: number[] }>(),
);
export const updateSeatStatusIdsFilterSelected = createAction(
  '[CatalogPlan] Update SeatStatusIds Filter Selected',
  props<{ seatStatusIdsFilterSelected: string[] }>(),
);
export const resetCatalogPlanFilters = createAction('[CatalogPlan] Reset Catalog Plan Filters');
/**
 * Meme etat vide que resetCatalogPlanFilters, mais AUCUN effect ne l'ecoute : a utiliser quand
 * l'appelant enchaine deja sur un rechargement complet de la vue (initializeFullPlanView ->
 * reloadPlanView, qui re-dispatche les 4 chargements). Sans cette action « pure », les listes de
 * filtre et les stats etaient refetchees 2 fois de suite a chaque validation de place.
 * La resynchro de l'UI du filtre global repose sur l'ETAT (applyPlanFilter vide), pas sur l'action :
 * elle continue de fonctionner a l'identique.
 */
export const clearCatalogPlanFilterSelection = createAction(
  '[CatalogPlan] Clear Catalog Plan Filter Selection',
);
export const applyPlanFilter = createAction('[CatalogPlan] Apply Plan Filters');
export const applyPlanFilterAndSelect = createAction(
  '[CatalogPlan] Apply Plan Filter And Select',
  props<{ contingentIds: number[]; categoryIds: number[]; unavailableSeatTypeIds: number[]; seatStatusIds: string[] }>(),
);
export const applyPlanFilterAndSelectSuccess = createAction(
  '[CatalogPlan] Apply Plan Filter And Select Success',
  props<{ bulkSelectionStats: EventSessionMultiSelectionStatsResponseDto }>(),
);
export const reloadPlanFilterDataSuccess = createAction(
  '[CatalogPlan] ReLoad Plan Filter Data Success',
  props<{
    planData: EventSessionPlanBlockResponseDto[];
  }>(),
);
export const updateSeatStatusOptionFilterSelected = createAction(
  '[CatalogPlan] Update SeatStatusOption Filter Selected',
  props<{ seatStatusOptionSelected: SeatStatusOptionFilter }>(),
);
export const setSeatColorsFilter = createAction(
  '[CatalogPlan] Set Seat Colors Filter',
  props<{ seatColorsFilter: SeatColorsTypeEnum[] }>(),
);
export const updateAllUnavailableSeats = createAction(
  '[CatalogPlan] Update All Unavailable Seats',
  props<{ allUnavailableSeats: EventSessionPlanUnavailableSeatTypesResponseDto[] }>(),
);
export const updateAllContingents = createAction(
  '[CatalogPlan] Update All Contingents',
  props<{ allContingents: EventSessionPlanContingentResponseDto[] }>(),
);
export const updateAllCategories = createAction(
  '[CatalogPlan] Update All Categories',
  props<{ allCategories: EventSessionPlanCategoryResponseDto[] }>(),
);
export const updateBlockCategories = createAction(
  '[CatalogPlan] Update Block Categories',
  props<{ blockCategories: EventSessionPlanCategoryResponseDto[] }>(),
);
export const updateBlockContingents = createAction(
  '[CatalogPlan] Update Block Contingents',
  props<{ blockContingents: EventSessionPlanContingentResponseDto[] }>(),
);
export const updateBlockUnavailableSeats = createAction(
  '[CatalogPlan] Update Block UnavailableSeats',
  props<{ blockUnavailableSeats: EventSessionPlanUnavailableSeatTypesResponseDto[] }>(),
);
export const loadAllUnavailableSeats = createAction(
  '[CatalogPlan] Load All Unavailable Seats',
  props<{ blockId?: number }>(),
);
export const loadAllContingents = createAction(
  '[CatalogPlan] Load All Contingents',
  props<{ blockId?: number }>(),
);
export const loadAllCategories = createAction(
  '[CatalogPlan] Load All Categories',
  props<{ blockId?: number }>(),
);
export const updateSeatSelection = createAction(
  '[CatalogPlan] Update Seat Selection',
  props<{ selection: CatalogPlanSeatResponseDto[]; withResetPlan?: boolean }>(),
);
export const resetSeatSelection = createAction('[CatalogPlan] Reset Seat Selection');
export const resetSeatSelectionSuccess = createAction('[CatalogPlan] Reset Seat Selection Success');
export const updateSelectedSeatChanges = createAction(
  '[CatalogPlan] update Selected Seat Changes',
  props<{
    selectedSeatChanges: {
      categoryId: number;
      contingentId: number;
      unavailabilityId: number;
    };
  }>(),
);

export const initializeFullPlanView = createAction('[CatalogPlan] Initialize and Refresh Plan');

export const updateMultiQuickFilter = createAction(
  '[CatalogPlan] Update Multi Quick Filter',
  props<{
    multiQuickFilter: MultiQuickFilterSelection;
  }>(),
);
export const resetMultiQuickFilter = createAction('[CatalogPlan] Reset Quick Type Filter');

export const refreshTopViewMinimapAvailabilities = createAction(
  '[CatalogPlan] Refresh TopView Minimap Availabilities',
);

export const updateViewSeatStatusStats = createAction(
  '[CatalogPlan] Update View Seat Status Stats',
  props<{ viewSeatStatusStats: EventSessionStatsResponseDto }>(),
);
export const updatePlanWideSeatStatusStats = createAction(
  '[CatalogPlan] Update Plan Wide Seat Status Stats',
  props<{ planWideSeatStatusStats: EventSessionStatsResponseDto }>(),
);
export const updateFilteredSeatStatusStats = createAction(
  '[CatalogPlan] Update Filtered Seat Status Stats',
  props<{ filteredSeatStatusStats: EventSessionMultiSelectionStatsResponseDto }>(),
);
// Stats multi-selection non filtrees du perimetre courant (bloc en vue bloc, plan en vue plan) :
// seule source portant totalSelectedSeats, donc le seul moyen de deduire le nombre de places libres.
export const updateViewMultiSelectionStats = createAction(
  '[CatalogPlan] Update View MultiSelection Stats',
  props<{ viewMultiSelectionStats: EventSessionMultiSelectionStatsResponseDto }>(),
);
export const loadViewSeatStatusStats = createAction('[CatalogPlan] Load View Seat Status Stats', props<{ blockId?: number }>());
// `scope` accompagne la CREATION d'une selection en masse : il gele le perimetre qui a produit ces
// stats (cf. BulkSelectionScope). Omis sur les chemins d'erreur (stats null) et sur toute mise a jour
// qui ne redefinit pas la selection — le reducer conserve alors le perimetre deja gele.
export const updateBulkSelectionStats = createAction(
  '[CatalogPlan] Update Bulk Selection Stats',
  props<{ bulkSelectionStats: EventSessionMultiSelectionStatsResponseDto; scope?: BulkSelectionScope }>(),
);
export const resetBulkSelectionStats = createAction('[CatalogPlan] Reset Bulk Selection Stats');
// Stats filtrees du BLOC courant, rafraichies a chaque entree dans un bloc tant qu'une selection en
// masse est gelee. Volontairement distinctes de bulkSelectionStats : elles ne doivent jamais ecraser
// la selection gelee (c'etait la cause de l'anomalie), et restent disponibles apres une annulation.
export const updateBlockScopedFilterStats = createAction(
  '[CatalogPlan] Update Block Scoped Filter Stats',
  props<{ blockScopedFilterStats: EventSessionMultiSelectionStatsResponseDto }>(),
);
